import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 5.8335H17.5",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 10H17.5",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M2.5 14.1665H17.5",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 15.5V13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.39172 2.85004L2.61672 7.47504C1.96672 7.9917 1.55006 9.08337 1.69172 9.90004L2.80006 16.5334C3.00006 17.7167 4.13339 18.675 5.33339 18.675H14.6667C15.8584 18.675 17.0001 17.7084 17.2001 16.5334L18.3084 9.90004C18.4417 9.08337 18.0251 7.9917 17.3834 7.47504L11.6084 2.85837C10.7167 2.1417 9.27506 2.1417 8.39172 2.85004Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/folder" }, [
      /*#__PURE__*/_createElementVNode("g", { id: "folder" }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Vector",
          d: "M18.3334 9.6665V14.6665C18.3334 17.9998 17.5001 18.8332 14.1667 18.8332H5.83341C2.50008 18.8332 1.66675 17.9998 1.66675 14.6665V6.33317C1.66675 2.99984 2.50008 2.1665 5.83341 2.1665H7.08341C8.33342 2.1665 8.60841 2.53317 9.08341 3.1665L10.3334 4.83317C10.6501 5.24984 10.8334 5.49984 11.6667 5.49984H14.1667C17.5001 5.49984 18.3334 6.33317 18.3334 9.6665Z",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10"
        })
      ])
    ])
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 12.2H15\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8 16.2H12.38\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.5013 18.3332H12.5013C16.668 18.3332 18.3346 16.6665 18.3346 12.4998V7.49984C18.3346 3.33317 16.668 1.6665 12.5013 1.6665H7.5013C3.33464 1.6665 1.66797 3.33317 1.66797 7.49984V12.4998C1.66797 16.6665 3.33464 18.3332 7.5013 18.3332Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 7.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 12.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "SVG namespace "
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.5013 18.3332H12.5013C16.668 18.3332 18.3346 16.6665 18.3346 12.4998V7.49984C18.3346 3.33317 16.668 1.6665 12.5013 1.6665H7.5013C3.33464 1.6665 1.66797 3.33317 1.66797 7.49984V12.4998C1.66797 16.6665 3.33464 18.3332 7.5013 18.3332Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 7.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 12.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.833252 18.3335H19.1666\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.4844 18.3417V14.625\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.5013 9.0752C15.4846 9.0752 14.668 9.89187 14.668 10.9085V12.8002C14.668 13.8168 15.4846 14.6335 16.5013 14.6335C17.518 14.6335 18.3347 13.8168 18.3347 12.8002V10.9085C18.3347 9.89187 17.518 9.0752 16.5013 9.0752Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1.75122 18.3333V5.02498C1.75122 3.34998 2.5846 2.5083 4.24293 2.5083H9.43458C11.0929 2.5083 11.9179 3.34998 11.9179 5.02498V18.3333\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.83398 6.875H8.95899\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.83398 10H8.95899\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.875 18.3335V15.2085\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M14.9999 5.96651C14.9499 5.95817 14.8916 5.95817 14.8416 5.96651C13.6916 5.92484 12.7749 4.98317 12.7749 3.81651C12.7749 2.62484 13.7332 1.6665 14.9249 1.6665C16.1166 1.6665 17.0749 2.63317 17.0749 3.81651C17.0666 4.98317 16.1499 5.92484 14.9999 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.1415 12.0333C15.2831 12.225 16.5415 12.025 17.4248 11.4333C18.5998 10.65 18.5998 9.36664 17.4248 8.58331C16.5331 7.99164 15.2581 7.79163 14.1165 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.9749 5.96651C5.0249 5.95817 5.08324 5.95817 5.13324 5.96651C6.28324 5.92484 7.1999 4.98317 7.1999 3.81651C7.1999 2.62484 6.24157 1.6665 5.0499 1.6665C3.85824 1.6665 2.8999 2.63317 2.8999 3.81651C2.90824 4.98317 3.8249 5.92484 4.9749 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.0001 12.1916C9.95015 12.1833 9.89181 12.1833 9.84181 12.1916C8.69181 12.1499 7.77515 11.2083 7.77515 10.0416C7.77515 8.84994 8.73348 7.8916 9.92514 7.8916C11.1168 7.8916 12.0751 8.85827 12.0751 10.0416C12.0668 11.2083 11.1501 12.1583 10.0001 12.1916Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.5751 14.8168C6.4001 15.6001 6.4001 16.8835 7.5751 17.6668C8.90843 18.5585 11.0918 18.5585 12.4251 17.6668C13.6001 16.8835 13.6001 15.6001 12.4251 14.8168C11.1001 13.9335 8.90843 13.9335 7.5751 14.8168Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 5.96651C14.95 5.95817 14.8917 5.95817 14.8417 5.96651C13.6917 5.92484 12.775 4.98317 12.775 3.81651C12.775 2.62484 13.7334 1.6665 14.925 1.6665C16.1167 1.6665 17.075 2.63317 17.075 3.81651C17.0667 4.98317 16.15 5.92484 15 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.9749 5.96651C5.0249 5.95817 5.08324 5.95817 5.13324 5.96651C6.28324 5.92484 7.1999 4.98317 7.1999 3.81651C7.1999 2.62484 6.24157 1.6665 5.0499 1.6665C3.85824 1.6665 2.8999 2.63317 2.8999 3.81651C2.90824 4.98317 3.8249 5.92484 4.9749 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 12.1916C9.95002 12.1833 9.89169 12.1833 9.84169 12.1916C8.69169 12.1499 7.77502 11.2083 7.77502 10.0416C7.77502 8.84994 8.73336 7.8916 9.92502 7.8916C11.1167 7.8916 12.075 8.85827 12.075 10.0416C12.0667 11.2083 11.15 12.1583 10 12.1916Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.57498 14.8168C6.39998 15.6001 6.39998 16.8835 7.57498 17.6668C8.90831 18.5585 11.0916 18.5585 12.425 17.6668C13.6 16.8835 13.6 15.6001 12.425 14.8168C11.1 13.9335 8.90831 13.9335 7.57498 14.8168Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 6.4585V10.8335",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.5668 7.14987V12.8498C17.5668 13.7832 17.0667 14.6499 16.2584 15.1249L11.3084 17.9832C10.5001 18.4499 9.50006 18.4499 8.68339 17.9832L3.73339 15.1249C2.92505 14.6582 2.42505 13.7915 2.42505 12.8498V7.14987C2.42505 6.21653 2.92505 5.34983 3.73339 4.87483L8.68339 2.0165C9.49172 1.54984 10.4917 1.54984 11.3084 2.0165L16.2584 4.87483C17.0667 5.34983 17.5668 6.2082 17.5668 7.14987Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 13.5V13.5833",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_35 = {
  class: "alerts",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "22",
  viewBox: "0 0 24 22",
  fill: "none"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.5 8.4585V12.8335",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.0668 9.14987V14.8498C18.0668 15.7832 17.5667 16.6499 16.7584 17.1249L11.8084 19.9832C11.0001 20.4499 10.0001 20.4499 9.18339 19.9832L4.23339 17.1249C3.42505 16.6582 2.92505 15.7915 2.92505 14.8498V9.14987C2.92505 8.21653 3.42505 7.34983 4.23339 6.87483L9.18339 4.0165C9.99172 3.54984 10.9917 3.54984 11.8084 4.0165L16.7584 6.87483C17.5667 7.34983 18.0668 8.2082 18.0668 9.14987Z",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.5 15.5V15.5833",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_39 = {
  key: 0,
  cx: "17.5",
  cy: "6",
  r: "6",
  fill: "#A30711",
  stroke: "none"
}
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M7.5 10.8335H12.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.5 13.3335H10.8333\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.33333 5H11.6667C13.3333 5 13.3333 4.16667 13.3333 3.33333C13.3333 1.66667 12.5 1.66667 11.6667 1.66667H8.33333C7.5 1.66667 6.66667 1.66667 6.66667 3.33333C6.66667 5 7.5 5 8.33333 5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.3335V13.3335C17.5 16.6668 16.6667 18.3335 12.5 18.3335H7.5C3.33333 18.3335 2.5 16.6668 2.5 13.3335V8.3335C2.5 4.5335 3.89167 3.5001 6.66667 3.3501\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"vuesax/linear/profile-circle\"><g id=\"profile-circle\"><path id=\"Vector\" d=\"M10.0999 10.6502C10.0416 10.6419 9.9666 10.6419 9.89994 10.6502C8.43327 10.6002 7.2666 9.40023 7.2666 7.92523C7.2666 6.41689 8.48327 5.19189 9.99993 5.19189C11.5083 5.19189 12.7333 6.41689 12.7333 7.92523C12.7249 9.40023 11.5666 10.6002 10.0999 10.6502Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M15.6166 16.1498C14.1333 17.5081 12.1666 18.3331 9.99997 18.3331C7.8333 18.3331 5.86663 17.5081 4.3833 16.1498C4.46663 15.3665 4.96663 14.5998 5.8583 13.9998C8.14163 12.4831 11.875 12.4831 14.1416 13.9998C15.0333 14.5998 15.5333 15.3665 15.6166 16.1498Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M10.0001 18.3332C14.6025 18.3332 18.3334 14.6022 18.3334 9.99984C18.3334 5.39746 14.6025 1.6665 10.0001 1.6665C5.39771 1.6665 1.66675 5.39746 1.66675 9.99984C1.66675 14.6022 5.39771 18.3332 10.0001 18.3332Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g></svg></figure>", 1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "options-documents" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h1", null, "Documentos", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 6L18 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_56 = { class: "options-mobile" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h1", null, "Menu", -1)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M10 15V12.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.39172 2.35004L2.61672 6.97504C1.96672 7.4917 1.55006 8.58337 1.69172 9.40004L2.80006 16.0334C3.00006 17.2167 4.13339 18.175 5.33339 18.175H14.6667C15.8584 18.175 17.0001 17.2084 17.2001 16.0334L18.3084 9.40004C18.4417 8.58337 18.0251 7.4917 17.3834 6.97504L11.6084 2.35837C10.7167 1.6417 9.27506 1.6417 8.39172 2.35004Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Home</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_61 = [
  _hoisted_58
]
const _hoisted_62 = {
  key: 0,
  class: "options"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18.3333 9.1665V14.1665C18.3333 17.4998 17.5 18.3332 14.1666 18.3332H5.83329C2.49996 18.3332 1.66663 17.4998 1.66663 14.1665V5.83317C1.66663 2.49984 2.49996 1.6665 5.83329 1.6665H7.08329C8.33329 1.6665 8.60829 2.03317 9.08329 2.6665L10.3333 4.33317C10.65 4.74984 10.8333 4.99984 11.6666 4.99984H14.1666C17.5 4.99984 18.3333 5.83317 18.3333 9.1665Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10"
    })
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", null, "Documentos", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_66 = [
  _hoisted_63,
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = { class: "options" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 1,
  class: "options"
}
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 12.2H15\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8 16.2H12.38\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Assuntos</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_73 = [
  _hoisted_70
]
const _hoisted_74 = { class: "options" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 2,
  class: "options"
}
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M7.5013 18.3332H12.5013C16.668 18.3332 18.3346 16.6665 18.3346 12.4998V7.49984C18.3346 3.33317 16.668 1.6665 12.5013 1.6665H7.5013C3.33464 1.6665 1.66797 3.33317 1.66797 7.49984V12.4998C1.66797 16.6665 3.33464 18.3332 7.5013 18.3332Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13.125 7.5H6.875\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13.125 12.5H6.875\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Modelos</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_80 = [
  _hoisted_77
]
const _hoisted_81 = { class: "options" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.5013 18.3332H12.5013C16.668 18.3332 18.3346 16.6665 18.3346 12.4998V7.49984C18.3346 3.33317 16.668 1.6665 12.5013 1.6665H7.5013C3.33464 1.6665 1.66797 3.33317 1.66797 7.49984V12.4998C1.66797 16.6665 3.33464 18.3332 7.5013 18.3332Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 7.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.125 12.5H6.875",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", null, "Ajuda", -1)
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = {
  key: 4,
  class: "options"
}
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.833252 18.3335H19.1666\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.4844 18.3417V14.625\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16.5013 9.0752C15.4846 9.0752 14.668 9.89187 14.668 10.9085V12.8002C14.668 13.8168 15.4846 14.6335 16.5013 14.6335C17.518 14.6335 18.3347 13.8168 18.3347 12.8002V10.9085C18.3347 9.89187 17.518 9.0752 16.5013 9.0752Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1.75122 18.3333V5.02498C1.75122 3.34998 2.5846 2.5083 4.24293 2.5083H9.43458C11.0929 2.5083 11.9179 3.34998 11.9179 5.02498V18.3333\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.83398 6.875H8.95899\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.83398 10H8.95899\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.875 18.3335V15.2085\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_89 = { class: "options" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 5,
  class: "options"
}
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M15 5.96651C14.95 5.95817 14.8917 5.95817 14.8417 5.96651C13.6917 5.92484 12.775 4.98317 12.775 3.81651C12.775 2.62484 13.7334 1.6665 14.925 1.6665C16.1167 1.6665 17.075 2.63317 17.075 3.81651C17.0667 4.98317 16.15 5.92484 15 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.9749 5.96651C5.0249 5.95817 5.08324 5.95817 5.13324 5.96651C6.28324 5.92484 7.1999 4.98317 7.1999 3.81651C7.1999 2.62484 6.24157 1.6665 5.0499 1.6665C3.85824 1.6665 2.8999 2.63317 2.8999 3.81651C2.90824 4.98317 3.8249 5.92484 4.9749 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 12.1916C9.95002 12.1833 9.89169 12.1833 9.84169 12.1916C8.69169 12.1499 7.77502 11.2083 7.77502 10.0416C7.77502 8.84994 8.73336 7.8916 9.92502 7.8916C11.1167 7.8916 12.075 8.85827 12.075 10.0416C12.0667 11.2083 11.15 12.1583 10 12.1916Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.57498 14.8168C6.39998 15.6001 6.39998 16.8835 7.57498 17.6668C8.90831 18.5585 11.0916 18.5585 12.425 17.6668C13.6 16.8835 13.6 15.6001 12.425 14.8168C11.1 13.9335 8.90831 13.9335 7.57498 14.8168Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Usuários</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_95 = [
  _hoisted_92
]
const _hoisted_96 = { class: "options" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 5.96651C14.95 5.95817 14.8917 5.95817 14.8417 5.96651C13.6917 5.92484 12.775 4.98317 12.775 3.81651C12.775 2.62484 13.7334 1.6665 14.925 1.6665C16.1167 1.6665 17.075 2.63317 17.075 3.81651C17.0667 4.98317 16.15 5.92484 15 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4.9749 5.96651C5.0249 5.95817 5.08324 5.95817 5.13324 5.96651C6.28324 5.92484 7.1999 4.98317 7.1999 3.81651C7.1999 2.62484 6.24157 1.6665 5.0499 1.6665C3.85824 1.6665 2.8999 2.63317 2.8999 3.81651C2.90824 4.98317 3.8249 5.92484 4.9749 5.96651Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 12.1916C9.95002 12.1833 9.89169 12.1833 9.84169 12.1916C8.69169 12.1499 7.77502 11.2083 7.77502 10.0416C7.77502 8.84994 8.73336 7.8916 9.92502 7.8916C11.1167 7.8916 12.075 8.85827 12.075 10.0416C12.0667 11.2083 11.15 12.1583 10 12.1916Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.57498 14.8168C6.39998 15.6001 6.39998 16.8835 7.57498 17.6668C8.90831 18.5585 11.0916 18.5585 12.425 17.6668C13.6 16.8835 13.6 15.6001 12.425 14.8168C11.1 13.9335 8.90831 13.9335 7.57498 14.8168Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Usuários</p>", 2)
const _hoisted_100 = [
  _hoisted_98
]
const _hoisted_101 = {
  key: 7,
  class: "options"
}
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M10 6.4585V10.8335\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.5666 7.14987V12.8498C17.5666 13.7832 17.0666 14.6499 16.2583 15.1249L11.3083 17.9832C10.5 18.4499 9.49994 18.4499 8.68327 17.9832L3.73327 15.1249C2.92493 14.6582 2.42493 13.7915 2.42493 12.8498V7.14987C2.42493 6.21653 2.92493 5.34983 3.73327 4.87483L8.68327 2.0165C9.4916 1.54984 10.4916 1.54984 11.3083 2.0165L16.2583 4.87483C17.0666 5.34983 17.5666 6.2082 17.5666 7.14987Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 13.5V13.5833\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Alertas</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_105 = [
  _hoisted_102
]
const _hoisted_106 = { class: "options" }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 6.4585V10.8335",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.5666 7.14987V12.8498C17.5666 13.7832 17.0666 14.6499 16.2583 15.1249L11.3083 17.9832C10.5 18.4499 9.49994 18.4499 8.68327 17.9832L3.73327 15.1249C2.92493 14.6582 2.42493 13.7915 2.42493 12.8498V7.14987C2.42493 6.21653 2.92493 5.34983 3.73327 4.87483L8.68327 2.0165C9.4916 1.54984 10.4916 1.54984 11.3083 2.0165L16.2583 4.87483C17.0666 5.34983 17.5666 6.2082 17.5666 7.14987Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 13.5V13.5833",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("p", null, "Alertas", -1)
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = {
  key: 9,
  class: "options"
}
const _hoisted_112 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7 13H15\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7 17H12\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 3.5C19.33 3.68 21 4.95 21 9.65V15.83C21 19.95 20 22.01 15 22.01H9C4 22.01 3 19.95 3 15.83V9.65C3 4.95 4.67 3.69 8 3.5H16Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Notas</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 3)
const _hoisted_115 = [
  _hoisted_112
]
const _hoisted_116 = { class: "options" }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<div class=\"item\"><figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M14.5333 12.1832L16.6667 10.0498L14.5333 7.9165\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.1333 10.0498H16.6083\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.79997 16.6668C6.11663 16.6668 3.1333 14.1668 3.1333 10.0002C3.1333 5.8335 6.11663 3.3335 9.79997 3.3335\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure><p>Sair</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" fill=\"none\"><path d=\"M4.58004 9.41016L11.1 15.9302C11.87 16.7002 13.13 16.7002 13.9 15.9302L20.42 9.41016\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1)
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10 15.5V13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.39172 2.85004L2.61672 7.47504C1.96672 7.9917 1.55006 9.08337 1.69172 9.90004L2.80006 16.5334C3.00006 17.7167 4.13339 18.675 5.33339 18.675H14.6667C15.8584 18.675 17.0001 17.7084 17.2001 16.5334L18.3084 9.90004C18.4417 9.08337 18.0251 7.9917 17.3834 7.47504L11.6084 2.85837C10.7167 2.1417 9.27506 2.1417 8.39172 2.85004Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/folder" }, [
      /*#__PURE__*/_createElementVNode("g", { id: "folder" }, [
        /*#__PURE__*/_createElementVNode("path", {
          id: "Vector",
          d: "M18.3334 9.6665V14.6665C18.3334 17.9998 17.5001 18.8332 14.1667 18.8332H5.83341C2.50008 18.8332 1.66675 17.9998 1.66675 14.6665V6.33317C1.66675 2.99984 2.50008 2.1665 5.83341 2.1665H7.08341C8.33342 2.1665 8.60841 2.53317 9.08341 3.1665L10.3334 4.83317C10.6501 5.24984 10.8334 5.49984 11.6667 5.49984H14.1667C17.5001 5.49984 18.3334 6.33317 18.3334 9.6665Z",
          "stroke-width": "1.5",
          "stroke-miterlimit": "10"
        })
      ])
    ])
  ])
], -1)
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 6.3335H18",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 10.5H18",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3 14.6665H18",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    })
  ])
], -1)
const _hoisted_125 = [
  _hoisted_124
]
const _hoisted_126 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5206 3.41016C9.21058 3.41016 6.52058 6.10016 6.52058 9.41016V12.3002C6.52058 12.9102 6.26058 13.8402 5.95058 14.3602L4.80058 16.2702C4.09058 17.4502 4.58058 18.7602 5.88058 19.2002C10.1906 20.6402 14.8406 20.6402 19.1506 19.2002C20.3606 18.8002 20.8906 17.3702 20.2306 16.2702L19.0806 14.3602C18.7806 13.8402 18.5206 12.9102 18.5206 12.3002V9.41016C18.5206 6.11016 15.8206 3.41016 12.5206 3.41016Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.3699 3.69994C14.0599 3.60994 13.7399 3.53994 13.4099 3.49994C12.4499 3.37994 11.5299 3.44994 10.6699 3.69994C10.9599 2.95994 11.6799 2.43994 12.5199 2.43994C13.3599 2.43994 14.0799 2.95994 14.3699 3.69994Z",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.5195 19.5601C15.5195 21.2101 14.1695 22.5601 12.5195 22.5601C11.6995 22.5601 10.9395 22.2201 10.3995 21.6801C9.85953 21.1401 9.51953 20.3801 9.51953 19.5601",
  "stroke-width": "1.5",
  "stroke-miterlimit": "10"
}, null, -1)
const _hoisted_130 = {
  key: 0,
  cx: "20",
  cy: "5",
  r: "5",
  fill: "#A30711",
  stroke: "none"
}
const _hoisted_131 = /*#__PURE__*/_createStaticVNode("<figure><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"vuesax/linear/profile-circle\"><g id=\"profile-circle\"><path id=\"Vector\" d=\"M10.0999 10.6502C10.0416 10.6419 9.9666 10.6419 9.89994 10.6502C8.43327 10.6002 7.2666 9.40023 7.2666 7.92523C7.2666 6.41689 8.48327 5.19189 9.99993 5.19189C11.5083 5.19189 12.7333 6.41689 12.7333 7.92523C12.7249 9.40023 11.5666 10.6002 10.0999 10.6502Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M15.6166 16.1498C14.1333 17.5081 12.1666 18.3331 9.99997 18.3331C7.8333 18.3331 5.86663 17.5081 4.3833 16.1498C4.46663 15.3665 4.96663 14.5998 5.8583 13.9998C8.14163 12.4831 11.875 12.4831 14.1416 13.9998C15.0333 14.5998 15.5333 15.3665 15.6166 16.1498Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M10.0001 18.3332C14.6025 18.3332 18.3334 14.6022 18.3334 9.99984C18.3334 5.39746 14.6025 1.6665 10.0001 1.6665C5.39771 1.6665 1.66675 5.39746 1.66675 9.99984C1.66675 14.6022 5.39771 18.3332 10.0001 18.3332Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g></svg></figure>", 1)
const _hoisted_132 = [
  _hoisted_131
]

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { isNotificationsModalOpen, newNotification, viewNotification} from '@/global/states/ModalState'
import { useAxios } from '@/api/axios'
import router from '@/router'
import { storageUrl, user } from '@/global/states/GlobalState'
import Loader from '@/components/loader/Loader.vue'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'

/* Defines whether the menu is open or not. */

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminLayoutMenu',
  setup(__props) {

const menuOpen = ref<boolean>(false)

const isLoggingOut = ref(false)

/* Open or close menu. */
const menuOpenOrClose = () => {
  menuOpen.value = !menuOpen.value
  optionListDocuments.value = false
  closeAllOptions()
  checkMenuIsOpen()
}

/* Open list menu options */
const openListOptionsMobile = (optionName: string) => {
  if (!menuOpen.value) {
    menuOpen.value = true
  }

  let latestValue = false

  switch (optionName) {
    case 'documents':
      latestValue = optionMobileListDocuments.value
      break
    case 'documents-subjects':
      latestValue = optionMobileListDocumentsSubjects.value
      break
    case 'sectors':
      latestValue = optionMobileListSectors.value
      break
    case 'users':
      latestValue = optionMobileListUsers.value
      break
    case 'models':
      latestValue = optionMobileListModels.value
      break
    case 'alerts':
      latestValue = optionMobileListAlerts.value
      break
    case 'notes':
      latestValue = optionMobileListNotes.value
      break
    default:
      console.error(`Opção inválida: ${optionName}`)
      return
  }

  closeAllOptionsMobile()

  switch (optionName) {
    case 'documents':
      optionMobileListDocuments.value = !latestValue
      break
    case 'documents-subjects':
      optionMobileListDocumentsSubjects.value = !latestValue
      break
    case 'sectors':
      optionMobileListSectors.value = !latestValue
      break
    case 'users':
      optionMobileListUsers.value = !latestValue
      break
    case 'models':
      optionMobileListModels.value = !latestValue
      break
    case 'alerts':
      optionMobileListAlerts.value = !latestValue
      break
    case 'notes':
      optionMobileListNotes.value = !latestValue
      break
    default:
      console.error(`Opção inválida: ${optionName}`)
      break
  }

  checkMenuIsOpen()
}

/* Open list menu options */
const openListOptions = (optionName?: string) => {
  if (!menuOpen.value) {
    menuOpen.value = true
  }

  let latestValue = false

  switch (optionName) {
    case 'documents':
      latestValue = !optionListDocuments.value
      break
    case 'documents-subjects':
      latestValue = !optionListDocumentsSubjects.value
      break
    case 'sectors':
      latestValue = !optionListSectors.value
      break
    case 'users':
      latestValue = !optionListUsers.value
      break
    case 'models':
      latestValue = !optionListModels.value
      break
    case 'alerts':
      latestValue = !optionListAlerts.value
      break
    case 'notes':
      latestValue = !optionListNotes.value
      break
    default:
      console.error(`Opção inválida: ${optionName}`)
      return
  }
  closeAllOptions()

  switch (optionName) {
    case 'documents':
      optionListDocuments.value = !latestValue
      break
    case 'documents-subjects':
      optionListDocumentsSubjects.value = !latestValue
      break
    case 'sectors':
      optionListSectors.value = !latestValue
      break
    case 'users':
      optionListUsers.value = !latestValue
      break
    case 'models':
      optionListModels.value = !latestValue
      break
    case 'alerts':
      optionListAlerts.value = !latestValue
      break
    case 'notes':
      optionListNotes.value = !latestValue
      break
    default:
      console.error(`Opção inválida: ${optionName}`)
      break
  }

  checkMenuIsOpen()
}

/* Close all oprtion mobile */
const closeAllOptionsMobile = () => {
  optionMobileListDocuments.value = false
  optionMobileListDocumentsSubjects.value = false
  optionMobileListSectors.value = false
  optionMobileListUsers.value = false
  optionMobileListModels.value = false
  optionMobileListAlerts.value = false
  optionMobileListNotes.value = false
}

/* Close all oprtion */
const closeAllOptions = () => {
  optionListDocuments.value = false
  optionListDocumentsSubjects.value = false
  optionListSectors.value = false
  optionListUsers.value = false
  optionListModels.value = false
  optionListAlerts.value = false
  optionListNotes.value = false
}

const optionListMenu = ref<boolean>(false)

/* Here are the item variables that have options mobile. */
const optionMobileListDocuments = ref<boolean>(false)
const optionMobileListDocumentsSubjects = ref<boolean>(false)
const optionMobileListSectors = ref<boolean>(false)
const optionMobileListUsers = ref<boolean>(false)
const optionMobileListModels = ref<boolean>(false)
const optionMobileListAlerts = ref<boolean>(false)
const optionMobileListNotes = ref<boolean>(false)

/* Here are the item variables that have options. */
const optionListDocuments = ref<boolean>(false)
const optionListDocumentsSubjects = ref<boolean>(false)
const optionListSectors = ref<boolean>(false)
const optionListUsers = ref<boolean>(false)
const optionListModels = ref<boolean>(false)
const optionListAlerts = ref<boolean>(false)
const optionListNotes = ref<boolean>(false)

/* List menu options */
const optionsListDocuments = computed<{ name: string, router: string, show: boolean }[]>(() => [
  { name: 'Criar', router: 'create-documents', show: user.value.can!('create_documents') },
  { name: 'Gerenciar', router: 'manage-documents', show: user.value.can!('read_documents') }
].filter(o => o.show))

const optionsListDocumentSubjects = computed<{ name: string, path: string, show: boolean }[]>(() => [
  { name: 'Criar', path: 'create-document-subjects', show: user.value.can!('create_document_subjects') },
  { name: 'Gerenciar', path: 'manage-document-subjects', show: user.value.can!('read_all_document_subjects') }
].filter(o => o.show))

const optionsListSectors = computed<{ name: string; router: string, show: boolean}[]>(() => [
  { name: 'Criar', router: 'create-organizations', show: user.value.can!('create_organizations') },
  { name: 'Gerenciar', router: 'manage-organizations', show: user.value.can!('create_organizations') && user.value.can!('read_organizations') }
].filter(o => o.show))

const optionsListUsers = computed<{ name: string; router: string, show: boolean }[]>(() => [
  { name: 'Criar', router: 'create-users', show: user.value.can!('create_users') },
  { name: 'Gerenciar', router: 'manage-users', show: user.value.can!('create_users') && user.value.can!('read_users') }
].filter(o => o.show))

const optionsListModels = computed<{ name: string; router: string, show: boolean }[]>(() => [
  { name: 'Criar', router: 'create-models', show: user.value.can!('create_models') },
  { name: 'Gerenciar', router: 'manage-models', show: user.value.can!('read_models') && user.value.can!('create_models') }
].filter(o => o.show))

const optionsListAlerts = computed<{ name: string; router: string, show: boolean }[]>(() => [
  { name: 'Criar', router: 'create-alerts', show: user.value.can!('create_alerts') },
  { name: 'Gerenciar', router: 'manage-alerts', show: user.value.can!('read_alerts') }
].filter(o => o.show))

const optionsListNotes = computed<{ name: string; router: string, show: boolean }[]>(() => [
  { name: 'Criar', router: 'create-notes', show: user.value.can!('create_documents') },
  { name: 'Gerenciar', router: 'manage-notes', show: user.value.can!('read_documents') }
].filter(o => o.show))

const axios = useAxios()

const logout = () => {
  isLoggingOut.value = true

  axios.post('/logout').then(() => {
    router.push({ name: 'login' })
  }).finally(() => isLoggingOut.value = false)
}

/* Assigns false to all options and assigns true to the selected options documents. */
const toggleOptionDocumentsSelected = (index: number) => {
  menuOpen.value = !menuOpen.value
  checkMenuIsOpen()
}

/* Check if the menu is open. */
const checkMenuIsOpen = () => {
  const screenWidth = window.innerWidth

  if (screenWidth > 425) {
    if (menuOpen.value) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  } else {
    if (optionListDocuments.value || optionListMenu.value) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    true
      ? (_openBlock(), _createElementBlock("nav", {
          key: 0,
          class: _normalizeClass(["desktop", { open: menuOpen.value }])
        }, [
          (_unref(user)?.tenant?.logo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                title: "Voltar para home",
                src: _unref(storageUrl) + _unref(user).tenant.logo as string,
                alt: "Logo Prefeitura de Canindé.",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {menuOpen.value = false; checkMenuIsOpen(); _ctx.$router.push('/admin/home')})
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            title: "Abrir menu",
            class: "menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {menuOpenOrClose();})
          }, _hoisted_3),
          _createElementVNode("button", {
            title: "Home",
            id: "home-menu",
            class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/home' || _ctx.$route.path === '/admin/results' }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$router.push('/admin/home'); menuOpen.value = false; checkMenuIsOpen(); closeAllOptions();})
          }, _hoisted_5, 2),
          (optionsListDocuments.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                title: "Documentos",
                id: "documents-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-documents' || _ctx.$route.path === '/admin/manage-documents' || _ctx.$route.path === '/admin/exceptions-documents' || _ctx.$route.path.includes('/admin/view-document'), opened: optionListDocuments.value }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => {optionListDocuments.value = !optionListDocuments.value; openListOptions('documents');})
              }, _hoisted_7, 2))
            : _createCommentVNode("", true),
          (optionsListDocuments.value.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 2,
                class: _normalizeClass({ opened: optionListDocuments.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListDocuments.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_9
                  ], 10, _hoisted_8))
                }), 256))
              ], 2))
            : _createCommentVNode("", true),
          (optionsListDocumentSubjects.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                title: "Assuntos de documento",
                id: "document-subjects-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path.includes('document-subject'), opened: optionListDocumentsSubjects.value }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => {optionListDocumentsSubjects.value = !optionListDocumentsSubjects.value; openListOptions('documents-subjects');})
              }, _hoisted_11, 2))
            : _createCommentVNode("", true),
          (optionsListDocumentSubjects.value.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 4,
                class: _normalizeClass({ opened: optionListDocumentsSubjects.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListDocumentSubjects.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.path}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.path}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_13
                  ], 10, _hoisted_12))
                }), 256))
              ], 2))
            : _createCommentVNode("", true),
          (optionsListModels.value.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                title: "Modelos",
                id: "models-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-models' || _ctx.$route.path === '/admin/manage-models' || _ctx.$route.path.includes('/admin/edit-model') || _ctx.$route.path === '/admin/help', opened: optionListModels.value }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => {optionListModels.value = !optionListModels.value; openListOptions('models');})
              }, _hoisted_15, 2))
            : _createCommentVNode("", true),
          (optionsListModels.value.length > 1)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 6,
                class: _normalizeClass({ opened: optionListModels.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListModels.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}`}),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_17
                  ], 10, _hoisted_16))
                }), 256))
              ], 2))
            : (_openBlock(), _createElementBlock("button", {
                key: 7,
                title: "Ajuda",
                id: "help",
                class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/help' }),
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$router.push('/admin/help'); menuOpen.value = false; checkMenuIsOpen(); closeAllOptions();})
              }, _hoisted_19, 2)),
          (optionsListSectors.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 8,
                title: _unref(user)?.tenant?.sector === _unref(TenantSectorEnum).CHAMBER ? 'Câmaras' : 'Setores',
                id: "sectors-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-organizations' || _ctx.$route.path === '/admin/manage-organizations' || _ctx.$route.path.includes('/admin/edit-organization'), opened: optionListSectors.value, chamber: _unref(user)?.tenant?.sector === _unref(TenantSectorEnum).CHAMBER }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => {optionListSectors.value = !optionListSectors.value; openListOptions('sectors');})
              }, _hoisted_22, 10, _hoisted_20))
            : _createCommentVNode("", true),
          (optionsListSectors.value.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 9,
                class: _normalizeClass({ opened: optionListSectors.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListSectors.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_24
                  ], 10, _hoisted_23))
                }), 256))
              ], 2))
            : _createCommentVNode("", true),
          (optionsListUsers.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 10,
                title: "Usuários",
                id: "users-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-users' || _ctx.$route.path === '/admin/manage-users' || _ctx.$route.path.includes('/admin/edit-user'), opened: optionListUsers.value }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => {optionListUsers.value = !optionListUsers.value; openListOptions('users');})
              }, _hoisted_26, 2))
            : _createCommentVNode("", true),
          (optionsListUsers.value.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 11,
                class: _normalizeClass({ opened: optionListUsers.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListUsers.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_28
                  ], 10, _hoisted_27))
                }), 256))
              ], 2))
            : (_openBlock(), _createElementBlock("button", {
                key: 12,
                title: "Usuários",
                id: "users-menu",
                class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/users' }),
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$router.push('/admin/users'); menuOpen.value = false; checkMenuIsOpen(); closeAllOptions();})
              }, _hoisted_30, 2)),
          (optionsListAlerts.value.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 13,
                title: "Alertas",
                id: "alerts-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-alerts' || _ctx.$route.path === '/admin/manage-alerts' || _ctx.$route.path.includes('/admin/edit-alert'), opened: optionListAlerts.value }]),
                onClick: _cache[10] || (_cache[10] = ($event: any) => {optionListAlerts.value = !optionListAlerts.value; openListOptions('alerts');})
              }, _hoisted_32, 2))
            : _createCommentVNode("", true),
          (optionsListAlerts.value.length > 1)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 14,
                class: _normalizeClass({ opened: optionListAlerts.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListAlerts.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_34
                  ], 10, _hoisted_33))
                }), 256))
              ], 2))
            : (optionsListAlerts.value.length == 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 15,
                  title: "Alertas",
                  id: "alerts-menu-normal",
                  class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/alerts' }),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$router.push('/admin/alerts'); menuOpen.value = false; checkMenuIsOpen(); closeAllOptions();})
                }, [
                  _createElementVNode("figure", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      false
                        ? (_openBlock(), _createElementBlock("circle", _hoisted_39))
                        : _createCommentVNode("", true)
                    ]))
                  ])
                ], 2))
              : _createCommentVNode("", true),
          (optionsListNotes.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 16,
                title: "Notas",
                id: "notes-menu",
                class: _normalizeClass(["options", { 'active': _ctx.$route.path === '/admin/create-notes' || _ctx.$route.path === '/admin/manage-notes' || _ctx.$route.path.includes('/admin/edit-note'), opened: optionListNotes.value }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => {optionListNotes.value = !optionListNotes.value; openListOptions('notes');})
              }, _hoisted_41, 2))
            : _createCommentVNode("", true),
          (optionsListNotes.value.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 17,
                class: _normalizeClass({ opened: optionListNotes.value })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListNotes.value, (option, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                    onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); menuOpenOrClose(); closeAllOptions();}
                  }, [
                    _createElementVNode("p", null, _toDisplayString(option.name), 1),
                    _hoisted_43
                  ], 10, _hoisted_42))
                }), 256))
              ], 2))
            : _createCommentVNode("", true),
          _hoisted_44,
          _createElementVNode("button", {
            title: "Perfil",
            id: "profile-menu",
            class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/profile' }),
            onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$router.push('/admin/profile'); menuOpen.value = false; checkMenuIsOpen(); closeAllOptions();})
          }, _hoisted_46, 2),
          _createElementVNode("button", {
            title: "Desconectar",
            id: "logout-menu",
            onClick: logout
          }, _hoisted_48)
        ], 2))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("nav", {
          key: 1,
          class: _normalizeClass(["mobile", { opened: optionListDocuments.value || optionListMenu.value, documents: optionListDocuments.value, menu: optionListMenu.value}])
        }, [
          _createElementVNode("ul", _hoisted_49, [
            _createElementVNode("li", null, [
              _hoisted_50,
              (_openBlock(), _createElementBlock("svg", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => {optionListDocuments.value = !optionListDocuments.value; checkMenuIsOpen();}),
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none"
              }, _hoisted_53))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListDocuments.value, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ 'selected': _ctx.$route.path === `/admin/${option.router}` }),
                onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); optionListDocuments.value = false; checkMenuIsOpen();}
              }, [
                _createElementVNode("p", null, _toDisplayString(option.name), 1),
                _hoisted_55
              ], 10, _hoisted_54))
            }), 256))
          ]),
          _createElementVNode("ul", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("li", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/home' || _ctx.$route.path === '/admin/results' }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.$router.push(`/admin/home`);})
              }, _hoisted_61, 2)
            ]),
            (optionsListDocuments.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-documents' || _ctx.$route.path === '/admin/manage-documents' || _ctx.$route.path === '/admin/exceptions-documents' || _ctx.$route.path === '/admin/document', opened: optionMobileListDocuments.value }]),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (openListOptionsMobile('documents')))
                  }, _hoisted_66, 2),
                  _createElementVNode("div", _hoisted_67, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListDocuments.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; optionListDocuments.value = false; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_68))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            (optionsListDocumentSubjects.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path.includes('document-subject'), opened: optionMobileListDocumentsSubjects.value }]),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (openListOptionsMobile('documents-subjects')))
                  }, _hoisted_73, 2),
                  _createElementVNode("div", _hoisted_74, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListDocumentSubjects.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.path}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.path}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; optionListDocuments.value = false; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_75))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            (optionsListModels.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_76, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-models' || _ctx.$route.path === '/admin/manage-models' || _ctx.$route.path.includes('/admin/edit-model') || _ctx.$route.path === '/admin/help', opened: optionMobileListModels.value }]),
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (openListOptionsMobile('models')))
                  }, _hoisted_80, 2),
                  _createElementVNode("div", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListModels.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_82))
                    }), 256))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.$router.push({ name: 'admin.help' }); optionListMenu.value = false; checkMenuIsOpen();}),
                  class: "options"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/help', opened: false }])
                  }, _hoisted_85, 2)
                ])),
            (optionsListSectors.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_86, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-organizations' || _ctx.$route.path === '/admin/manage-organizations' || _ctx.$route.path.includes('/admin/edit-organization'), opened: optionMobileListSectors.value }]),
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (openListOptionsMobile('sectors')))
                  }, [
                    _hoisted_87,
                    _createElementVNode("p", null, _toDisplayString(_unref(user)?.tenant?.sector === _unref(TenantSectorEnum).CHAMBER ? 'Câmaras' : 'Setores'), 1),
                    _hoisted_88
                  ], 2),
                  _createElementVNode("div", _hoisted_89, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListSectors.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_90))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            (optionsListUsers.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_91, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-users' || _ctx.$route.path === '/admin/manage-users' || _ctx.$route.path.includes('/admin/edit-user'), opened: optionMobileListUsers.value }]),
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (openListOptionsMobile('users')))
                  }, _hoisted_95, 2),
                  _createElementVNode("div", _hoisted_96, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListUsers.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active': _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_97))
                    }), 256))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("li", {
                  key: 6,
                  onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.$router.push('/admin/users'); optionListMenu.value = false; checkMenuIsOpen();}),
                  class: "options"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/users', opened: false }])
                  }, _hoisted_100, 2)
                ])),
            (optionsListAlerts.value.length > 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_101, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-alerts' || _ctx.$route.path === '/admin/manage-alerts' || _ctx.$route.path.includes('/admin/edit-alert'), opened: optionMobileListAlerts.value }]),
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (openListOptionsMobile('alerts')))
                  }, _hoisted_105, 2),
                  _createElementVNode("div", _hoisted_106, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListAlerts.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_107))
                    }), 256))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("li", {
                  key: 8,
                  onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.$router.push({ name: 'admin.alerts' }); optionListMenu.value = false; checkMenuIsOpen();}),
                  class: "options"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/alerts', opened: false }])
                  }, _hoisted_110, 2)
                ])),
            (optionsListNotes.value.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_111, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["item", { 'active': _ctx.$route.path === '/admin/create-notes' || _ctx.$route.path === '/admin/manage-notes' || _ctx.$route.path.includes('/admin/edit-note'), opened: optionMobileListNotes.value }]),
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (openListOptionsMobile('notes')))
                  }, _hoisted_115, 2),
                  _createElementVNode("div", _hoisted_116, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsListNotes.value, (option) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: _normalizeClass({ 'active' : _ctx.$route.path === `/admin/${option.router}`}),
                        onClick: ($event: any) => {_ctx.$router.push(`/admin/${option.router}`); closeAllOptionsMobile(); optionListMenu.value = !optionListMenu.value; checkMenuIsOpen();}
                      }, _toDisplayString(option.name), 11, _hoisted_117))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              onClick: _cache[26] || (_cache[26] = ($event: any) => {logout(); menuOpen.value = false; checkMenuIsOpen();})
            }, _hoisted_119)
          ]),
          _createElementVNode("button", {
            class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/home' || _ctx.$route.path === '/admin/results' }),
            onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.$router.push('/admin/home'); menuOpen.value = false; optionListDocuments.value = false; checkMenuIsOpen();})
          }, _hoisted_121, 2),
          _createElementVNode("button", {
            class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/create-documents' || _ctx.$route.path === '/admin/manage-documents' || _ctx.$route.path === '/admin/exceptions-documents' || _ctx.$route.path.includes('/admin/view-document'), opened: optionListDocuments.value}),
            onClick: _cache[28] || (_cache[28] = ($event: any) => {optionListDocuments.value = !optionListDocuments.value; optionListMenu.value = false; checkMenuIsOpen();})
          }, _hoisted_123, 2),
          _createElementVNode("button", {
            onClick: _cache[29] || (_cache[29] = ($event: any) => {optionListMenu.value = !optionListMenu.value; optionListDocuments.value = false; checkMenuIsOpen(); closeAllOptionsMobile();})
          }, _hoisted_125),
          _createElementVNode("button", {
            class: "notify",
            onClick: _cache[30] || (_cache[30] = ($event: any) => {isNotificationsModalOpen.value = true; _unref(viewNotification)(true)})
          }, [
            _createElementVNode("figure", null, [
              (_openBlock(), _createElementBlock("svg", _hoisted_126, [
                _hoisted_127,
                _hoisted_128,
                _hoisted_129,
                (_unref(newNotification))
                  ? (_openBlock(), _createElementBlock("circle", _hoisted_130))
                  : _createCommentVNode("", true)
              ]))
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass({ 'active': _ctx.$route.path === '/admin/profile' }),
            onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.$router.push('/admin/profile'); menuOpen.value = false; optionListDocuments.value = false; checkMenuIsOpen();})
          }, _hoisted_132, 2)
        ], 2))
      : _createCommentVNode("", true),
    (isLoggingOut.value)
      ? (_openBlock(), _createBlock(Loader, {
          key: 2,
          zIndex: 10
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "blackdrop",
      onClick: _cache[32] || (_cache[32] = ($event: any) => (menuOpenOrClose()))
    }),
    _createElementVNode("div", {
      class: "blackdrop-mobile",
      onClick: _cache[33] || (_cache[33] = ($event: any) => {optionListDocuments.value = false; optionListMenu.value = false; openListOptions(); checkMenuIsOpen();})
    })
  ], 64))
}
}

})